export default "__VITE_ASSET__BAoPloIO__"